import React, { useState } from 'react';
import DesktopEnvironment from './components/Desktop/DesktopEnvironment';
import MobileDesktop from './components/Mobile/MobileDesktop';
import LockScreen from './components/LockScreen/LockScreen';
import { DesktopProvider } from './contexts/DesktopContext';
import { WindowProvider } from './contexts/WindowContext';
import { useResponsive } from './hooks/useResponsive';
import ErrorBoundary from './components/ErrorBoundary';
import GlobalScrollbarStyles from './utils/GlobalScrollbarStyles';
import './App.css';

function App() {
  const [isLocked, setIsLocked] = useState(true);
  const { isMobile } = useResponsive();

  const handleUnlock = () => {
    setIsLocked(false);
  };

  return (
    <ErrorBoundary>
      <GlobalScrollbarStyles />
      <div className="App">
        {isLocked ? (
          <LockScreen onUnlock={handleUnlock} />
        ) : (
          <DesktopProvider>
            <WindowProvider>
              {isMobile ? <MobileDesktop /> : <DesktopEnvironment />}
            </WindowProvider>
          </DesktopProvider>
        )}
      </div>
    </ErrorBoundary>
  );
}

export default App;
